import React from 'react';
import type {SubLabel} from '@deezer/next/features/ClaimAccess/types';
import Row from '@components/Table/rows/Row';
import {useTableContext} from '@components/Table';
import {LabelTableColumn} from './types';
import IconButtonCell from '@components/Table/cells/IconButtonCell';
import {PenIcon, TrashIcon} from '@tempo/icons';
import LabelNameCell from './LabelNameCell';
import UPCCell from '@components/Table/cells/UPCCell';

type LabelTableRowProps = {
	label: SubLabel;
	rowIndex: number;
	onLabelEdit: (label: SubLabel) => void;
	onLabelRemove: (label: SubLabel) => void;
};

const LabelTableRow = ({
	label,
	rowIndex,
	onLabelEdit,
	onLabelRemove,
}: LabelTableRowProps) => {
	const {columns} = useTableContext<LabelTableColumn>();

	const handleRemoveClick = () => {
		onLabelRemove(label);
	};

	const handleEditClick = () => {
		onLabelEdit(label);
	};

	return (
		<Row key={rowIndex} index={rowIndex}>
			{columns.map((column, index) => {
				const key = column.id + index;
				switch (column.id) {
					case LabelTableColumn.NAME:
						return (
							<LabelNameCell key={key} label={label} display={column.display} />
						);
					case LabelTableColumn.UPC:
						return (
							<UPCCell key={key} upc={label.upc} display={column.display} />
						);
					case LabelTableColumn.EDIT:
						return (
							<IconButtonCell
								key={key}
								aria-label={'edit'}
								icon={<PenIcon />}
								display={column.display}
								onClick={handleEditClick}
							/>
						);
					case LabelTableColumn.DELETE:
						return (
							<IconButtonCell
								key={key}
								aria-label={'delete'}
								icon={<TrashIcon />}
								display={column.display}
								onClick={handleRemoveClick}
							/>
						);
				}
			})}
		</Row>
	);
};

export default LabelTableRow;
